const runtimeConfig = window.__APP_CONFIG__ || {};

const config = {
  USER_ONBOARDING:
    runtimeConfig.REACT_APP_USER_ONBOARDING || "",

  BASE_URL:
    runtimeConfig.REACT_APP_BASE_URL || "",

  API_BASE:
    runtimeConfig.REACT_APP_API_BASE || "",

  RECAPTCHA_SITE_KEY:
    runtimeConfig.REACT_APP_RECAPTCHA_SITE_KEY || ""
};

export default config;